// Progressive-enhancement filter for the /projects/ index.
// Cards carry data-sector / data-region / data-funder; the form selects
// toggle them. Initial state is read from the URL query string so filtered
// views are shareable. With JS disabled, every project simply stays visible.
function setupProjectFilter() {
  const form = document.getElementById('project-filter')
  if (!form) return

  const grid = document.getElementById('project-grid')
  if (!grid) return

  const empty = document.getElementById('filter-empty')
  const cards = Array.from(grid.querySelectorAll('[data-sector]'))
  const keys = ['sector', 'region', 'funder']

  const readFilters = () => {
    const values = {}
    keys.forEach((key) => {
      values[key] = form.querySelector(`[name="${key}"]`).value
    })
    return values
  }

  const apply = () => {
    const active = readFilters()
    let visible = 0

    cards.forEach((card) => {
      const match = keys.every((key) => {
        const value = active[key]
        return !value || card.dataset[key] === value
      })
      card.hidden = !match
      if (match) visible += 1
    })

    if (empty) empty.hidden = visible > 0

    const params = new URLSearchParams()
    keys.forEach((key) => {
      if (active[key]) params.set(key, active[key])
    })
    const query = params.toString()
    const url = query
      ? `${window.location.pathname}?${query}`
      : window.location.pathname
    window.history.replaceState(null, '', url)
  }

  // Seed select values from the URL so filtered links restore on load.
  const initial = new URLSearchParams(window.location.search)
  keys.forEach((key) => {
    const select = form.querySelector(`[name="${key}"]`)
    const value = initial.get(key)
    if (value && Array.from(select.options).some((option) => option.value === value)) {
      select.value = value
    }
  })

  form.addEventListener('change', apply)
  form.addEventListener('reset', () => window.requestAnimationFrame(apply))

  apply()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupProjectFilter)
} else {
  setupProjectFilter()
}
